import React from "react";
import classNames from "classnames";

const ShimmerWrapper = ({
  children,
  className = "",
  spacing = 12,
  direction = "column",
  align,
  justify,
  wrap = false,
  display = "flex",
  border = false,
  borderRadius = 6,
  padding,
  width,
  height,
  flex,
  style = {},
}) => {
  return (
    <div
      className={classNames("shimmer-wrapper", border && "shimmer-wrapper--bordered", className)}
      style={{
        display,
        flexDirection: direction,
        gap: spacing,
        ...(align != null && { alignItems: align }),
        ...(justify != null && { justifyContent: justify }),
        ...(wrap && { flexWrap: "wrap" }),
        ...(border && { border: "1px solid #e5e7eb" }),
        ...(borderRadius != null && { borderRadius }),
        ...(padding != null && { padding }),
        ...(width != null && { width }),
        ...(height != null && { height }),
        ...(flex != null && { flex }),
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default ShimmerWrapper;